import * as actionTypes from './actionTypes';
import * as ShipConstants from '../../Global/Constants';

export const updateMessageState = (type, msg) => {
	return {
		type: actionTypes.MESSAGES,
		msgType : type,
		msg: msg
	};
}

export const errorBoundaryMsg = (bool) => {
	return {
		type: actionTypes.BOUNDARY_WARNING,
		bool: bool
	};
}

export const clearMessage = () => {
	return {
		type: actionTypes.CLEAR_MESSAGES
	};
}

export const succMessage = (msg) => {
	return dispatch => {
		dispatch(updateMessageState(ShipConstants.SUCCESS_MSG, msg));
		setTimeout(() => {
		    setTimeout(() => dispatch(clearMessage()));
	  	}, 5000);
	};
}

/** Collect rapid fail toasts into one (e.g. Kitchen Sink preload of several missing configs). */
let pendingFailMessages = [];
let failFlushTimer = null;
let failClearTimer = null;

const splitFailMessageParts = (msg) => {
	if (msg == null) return [];
	return String(msg)
		.split(/<\/?br\s*\/?>/gi)
		.map((s) => s.trim())
		.filter(Boolean);
};

const pushUniqueFailParts = (parts) => {
	parts.forEach((part) => {
		if (part && !pendingFailMessages.includes(part)) {
			pendingFailMessages.push(part);
		}
	});
};

export const failMessage = (msg) => {
	return (dispatch, getState) => {
		const parts = splitFailMessageParts(msg);
		if (parts.length === 0) return;

		pushUniqueFailParts(parts);

		// Late errors: keep lines already shown in the current Error toast.
		try {
			const state = typeof getState === "function" ? getState() : null;
			if (
				state?.commonReducer?.dispMsg &&
				state?.commonReducer?.msgType === ShipConstants.FAIL_MSG &&
				state?.commonReducer?.msg
			) {
				pushUniqueFailParts(splitFailMessageParts(state.commonReducer.msg));
			}
		} catch (e) {
			// ignore
		}

		if (failFlushTimer) {
			clearTimeout(failFlushTimer);
		}
		if (failClearTimer) {
			clearTimeout(failClearTimer);
			failClearTimer = null;
		}

		// Collect parallel page-open failures, then show once (same 5s as other toasts).
		failFlushTimer = setTimeout(() => {
			const combined = pendingFailMessages.join('</br>');
			pendingFailMessages = [];
			failFlushTimer = null;
			dispatch(updateMessageState(ShipConstants.FAIL_MSG, combined));
			failClearTimer = setTimeout(() => {
				failClearTimer = null;
				dispatch(clearMessage());
			}, 5000);
		}, 450);
	};
}

export const warningMessage = (msg) => {
	return dispatch => {
		dispatch(updateMessageState(ShipConstants.WARN_MSG, msg));
		setTimeout(() => {
		    setTimeout(() => dispatch(clearMessage()));
	  	}, 5000);
	};
}

export const infoMessage = (msg) => {
	return dispatch => {
		dispatch(updateMessageState(ShipConstants.INFO_MSG, msg));
		setTimeout(() => {
		    setTimeout(() => dispatch(clearMessage()));
	  	}, 5000);
	};
}
